module.exports = __webpack_public_path__ + "static/img/bg-ktp-sample.4226c9c0.png";